import React, { useState } from "react";
import { Modal } from "antd";
import InspectionChecklistForm from "src/components/inspection/InspectionChecklistForm";

/**
 * InspectionLinkBlock — зөрчилтэй ХОЛБООТОЙ хяналт шалгалтын хураангуй.
 *
 * Жагсаалтын ЗАДАРДАГ мөрөнд ба ДЭЛГЭРЭНГҮЙ цонхонд ХОЁУЛАНД нь
 * ашиглагдана — нэг эх сурвалж, хоёр газар зөрөхгүй.
 *
 * ⚠ ХОЛБООС НЬ ТААМАГ: `inspection_item_result.hazard_report_id` багана
 *   байгаа ч түүнийг бичдэг код одоогоор алга. Тиймээс backend
 *   (_attach_inspection) нь «ижил нэгж + ижил өдөр (+ шат)» гэсэн
 *   ХЭРЭГЛЭГЧИЙН ЛОГИКООР тулгадаг. Үүнийг доор ИЛ бичнэ — хэрэглэгч
 *   баттай холбоос гэж эндүүрэхгүй.
 */
export default function InspectionLinkBlock({ it, compact }) {
  const list = Array.isArray(it?.inspections) ? it.inspections : [];
  /* Хуудсыг БҮТНЭЭР харах — хураангуй нь зөвхөн зөрчилтэй мөрийг харуулдаг
     тул «үлдсэн үзүүлэлтүүд юу байсан бэ, бүгд хэвийн үү» гэдгийг шалгах
     арга байхгүй байв. Тусдаа хуудас руу шилжихгүйгээр модал дотор нээнэ —
     хэрэглэгч зөрчлийн хуудсаа алдахгүй. */
  const [sheetOf, setSheetOf] = useState(null);
  if (!list.length) {
    return compact ? null : (
      <div style={{ fontSize: 12, color: "#9AA3B0" }}>
        Тухайн өдөр энэ нэгжид бүртгэгдсэн хяналт шалгалт олдсонгүй.
      </div>
    );
  }
  const STAGE_NAME = {
    1: "I шат",
    2: "II шат",
    3: "III шат",
    4: "IV шат",
    5: "Зорилтот",
    6: "Байнгын",
    7: "Ээлжит бус",
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {list.map((ins) => {
        const pct = ins.total ? Math.round((ins.answered / ins.total) * 100) : 0;
        const done = ins.total > 0 && ins.answered >= ins.total;
        const accent = done ? "#16A34A" : pct > 0 ? "#CA8A04" : "#9AA3B0";
        return (
          <div
            key={ins.id}
            style={{
              border: "1px solid #E6E9EF",
              borderLeft: `3px solid ${accent}`,
              borderRadius: 8,
              background: "#fff",
              padding: "8px 12px",
            }}
          >
            {/* Толгой — дугаар, шат, төлөв, бөглөлт */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <span
                style={{
                  fontFamily: "monospace",
                  fontWeight: 700,
                  fontSize: 12,
                  color: "#1F2430",
                }}
              >
                {ins.code}
              </span>
              <span
                style={{
                  fontSize: 10.5,
                  fontWeight: 700,
                  padding: "1px 8px",
                  borderRadius: 999,
                  background: "#EEF2F7",
                  color: "#5A6478",
                }}
              >
                {STAGE_NAME[ins.stage_id] || `шат ${ins.stage_id}`}
              </span>
              <span
                style={{
                  fontSize: 10.5,
                  fontWeight: 700,
                  padding: "1px 8px",
                  borderRadius: 999,
                  background: ins.status === "closed" ? "#E7F6EC" : "#FEF6E7",
                  color: ins.status === "closed" ? "#16A34A" : "#CA8A04",
                }}
              >
                {ins.status === "closed" ? "Хаагдсан" : "Нээлттэй"}
              </span>
              <span style={{ marginLeft: "auto", fontSize: 11.5, color: accent, fontWeight: 700 }}>
                Бөглөлт {ins.answered}/{ins.total} ({pct}%)
              </span>
              <button
                type="button"
                title="Хяналтын хуудсыг бүтнээр харах"
                onClick={() => setSheetOf(ins)}
                style={{
                  height: 26,
                  padding: "0 10px",
                  borderRadius: 7,
                  border: "1px solid #0F6E5644",
                  background: "#0F6E5612",
                  color: "#0F6E56",
                  fontSize: 11.5,
                  fontWeight: 700,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                {/* `fa-tasks` = FA5 нэр. Төсөлд Font Awesome FREE 5.11.2
                    суусан тул FA6-ийн `fa-list-check` ХАРАГДАХГҮЙ. */}
                <i className="fas fa-tasks" style={{ marginRight: 5 }} />
                Хуудсыг харах
              </button>
            </div>

            {/* Явцын зураас */}
            <div
              style={{
                height: 5,
                borderRadius: 3,
                background: "#EDEFF3",
                marginTop: 6,
                overflow: "hidden",
              }}
            >
              <div style={{ width: `${pct}%`, height: 5, background: accent }} />
            </div>

            <div style={{ fontSize: 11, color: "#8A94A6", marginTop: 5 }}>
              {[ins.bn_name, ins.tseh_name, ins.area_location, ins.inspection_date]
                .filter(Boolean)
                .join(" · ")}
              {ins.inspector_name ? ` · шалгасан: ${ins.inspector_name}` : ""}
            </div>

            {/* Илэрсэн зөрчил + хэнд үүрэг өгсөн */}
            {ins.findings?.length ? (
              <div style={{ marginTop: 7 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#DC2626" }}>
                  Илэрсэн зөрчил ({ins.findings.length})
                </div>
                {ins.findings.map((f, i) => (
                  <div
                    key={i}
                    style={{
                      fontSize: 11.5,
                      color: "#1F2430",
                      marginTop: 3,
                      paddingLeft: 8,
                      borderLeft: "2px solid #FDECEC",
                      lineHeight: 1.5,
                    }}
                  >
                    <b>#{f.item_no}</b> {f.finding_text || f.item_text}
                    {f.violated_rule ? (
                      <span style={{ color: "#8A94A6" }}> · {f.violated_rule}</span>
                    ) : null}
                    {f.responsible_name ? (
                      <div style={{ fontSize: 11, color: "#5A6478" }}>
                        <i className="fas fa-user-check" style={{ marginRight: 4 }} />
                        {f.responsible_name}
                        {f.due_date ? ` · ${f.due_date} хүртэл` : ""}
                        {f.fix_status === "closed" ? " · биелсэн" : ""}
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: 11.5, color: "#16A34A", marginTop: 6 }}>
                Энэ шалгалтад зөрчил бүртгэгдээгүй.
              </div>
            )}
          </div>
        );
      })}
      <div style={{ fontSize: 10.5, color: "#A8AFBC" }}>
        ⓘ Холбоос нь «ижил бүтцийн нэгж + ижил өдөр» зарчмаар тулгагдсан —
        шууд гадаад түлхүүр биш.
      </div>

      {/* Хяналтын хуудас БҮТНЭЭР — /inspection/xab/:id хуудастай ИЖИЛ
          компонент (InspectionChecklistForm). Тусад нь хуудас үүсгээгүй. */}
      <Modal
        open={!!sheetOf}
        onCancel={() => setSheetOf(null)}
        footer={null}
        width={1040}
        style={{ top: 20 }}
        destroyOnClose
        title={
          <span>
            Хяналтын хуудас — {sheetOf?.code}
            <div style={{ fontSize: 11.5, color: "#9AA3B0", fontWeight: 400 }}>
              {[sheetOf?.bn_name, sheetOf?.tseh_name, sheetOf?.inspection_date]
                .filter(Boolean)
                .join(" · ")}
            </div>
          </span>
        }
      >
        <div style={{ maxHeight: "78vh", overflowY: "auto" }}>
          {sheetOf ? (
            <InspectionChecklistForm
              inspectionId={sheetOf.id}
              onClosed={() => setSheetOf(null)}
            />
          ) : null}
        </div>
      </Modal>
    </div>
  );
}

